import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PopUpTitles } from 'src/app/shared/model/enum';

@Component({
  selector: 'app-add-edit-mailing-list',
  templateUrl: './add-edit-mailing-list.component.html',
  styleUrls: ['./add-edit-mailing-list.component.scss']
})
export class AddEditMailingListComponent implements OnInit {
  @Input() isAddValue: boolean;
  enumPopUpTitles = PopUpTitles;
  constructor(public activeModal: NgbActiveModal,) { }

  ngOnInit(): void {
  }

  addEditValue(){

  }

  
 
}
